import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 30000 } }

  connect() {
    this.load()
    this.timer = setInterval(() => this.load(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async load() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })

      if (response.ok) {
        const html = await response.text()
        if (html.trim().length > 0) {
          this.element.innerHTML = html
          this.element.classList.remove("hidden")
        } else {
          this.element.classList.add("hidden")
        }
      }
    } catch {
      // Silently fail — feed is non-critical
    }
  }
}
